import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import { MainNavbar } from './MainNavbar';
import { ImageButton } from '../../shared/components/button/ImageButton';
import { AppBar, Container } from '@mui/material';
import { FeatureToggle, LoginDropdownItems, MainNavbarLinks, SiteAlert, SubNavigationMenusData } from '../../shared/models/app-data-model';
import './GlobalNavigation.scss';
import SubNavigation from '../sub-navigation/SubNavigation';
import AlertComponent from '../../shared/components/alert-component/AlertComponent';
import useFeatureToggle from '../../shared/hooks/use-feature-toggle/useFeatureToggle';

interface GlobalNavigationProps {
  mainNavLinks: MainNavbarLinks[];
  subNav: SubNavigationMenusData;
  globalAlert: SiteAlert[];
  featureToggles: FeatureToggle[];
  loginDropdownItems: LoginDropdownItems;
}

export function GlobalNavigation({ mainNavLinks, subNav, globalAlert, featureToggles, loginDropdownItems }: GlobalNavigationProps) {
  const isSubNavEnabled = useFeatureToggle('sub-nav', featureToggles);
  
  return (
    <AppBar className='app-bar' elevation={0} role="menubar">
      {globalAlert && globalAlert.map((alert, index) => <AlertComponent message={alert.alert_message} severityLevel={alert.alert_type} button={alert.button} key={index}></AlertComponent>)}

      <div className="site-header">
        <Container maxWidth="xl" disableGutters>
          <Toolbar disableGutters sx={(theme) => ({
            [theme.breakpoints.down("md")]: {
              display: "flex",
              justifyContent: "space-between"
            }
          })}>
            <ImageButton
              route=""
              imageSource="https://priorityhealth.stylelabs.cloud/api/public/content/a4d5f25865da4fc1a6ac395fe0f41f5f?v=587f753f"
            />
            <MainNavbar mainNavbarLinks={mainNavLinks} featureToggles={featureToggles} loginDropdownItems={loginDropdownItems} />
          </Toolbar>
        </Container>
      </div>

      {isSubNavEnabled && subNav && <SubNavigation subNavigationMenus={subNav} featureToggles={featureToggles} />}
    </AppBar>
  );
}
